export default __webpack_public_path__ + "static/media/value-proposition-icon.7bd347db.svg";